<template>
	<v-layout>
		<div :class="$route.name === 'home' ? 'logo_1' : 'about_logo_1'"></div>
		<v-spacer></v-spacer>
		<v-layout justify-end>
			<div v-for="(tab, i) in $store.state.tabList" :key="i" :class="$route.name === 'home' ? 'tab-css-1' : 'about-tab-css-1'">
				<div class="number cursor">0{{ i + 1 }}</div>
				<div class="Title cursor" :style="i < 4 ? 'padding-right: 40px;' : 'padding-right: 0px;'" @click="titleGoto(tab.link)">
					{{ tab.title }}
				</div>
				<div class="dot mt-2" v-show="showDot(i)"></div>
			</div>
			<v-btn
				depressed
				color="iconColor1"
				rounded
				dark
				class="mt-4 ml-6"
				v-if="$route.name === 'home'"
				@click="$router.push({ name: 'contact' })"
			>
				Submit Application
			</v-btn>
			<v-btn depressed color="btnColor1" rounded class="mt-4 ml-6 btn-font-color-1" v-else @click="$router.push({ name: 'contact' })">
				Submit Application
			</v-btn>
		</v-layout>
	</v-layout>
</template>
<script>
export default {
	data() {
		return {}
	},
	methods: {
		emailSend() {
			window.open('mailto:contact@bdavc.com')
		},
		showDot(i) {
			if (this.$route.name === 'home') {
				return i === 0
			} else if (this.$route.name === 'about') {
				return i === 1
			} else if (this.$route.name === 'team') {
				return i === 2
			} else if (this.$route.name === 'portfolio') {
				return i === 3
			} else if (this.$route.name === 'contact') {
				return i === 4
			}
		},
		titleGoto(link) {
			this.$router.push({ name: link })
		},
	},
}
</script>
<style lang="scss">
.btn-font-color-1 {
	color: #4b83fc !important;
}
</style>
